import React, {Component} from 'react'

import { connect } from 'react-redux'
import { show as showModal } from 'redux-modal'
import SettingsLocation from './components/Settings/SettingsLocation'
import SettingsStep from './components/Settings/SettingsStep'
import { fetchAgentMvipSettings } from '../redux/settings.js'

import {
  setTitle
} from 'common/redux/root'

import {
  saveLocation
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsLocationContainer extends Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(setTitle("My Location"))
    this.props.dispatch(fetchAgentMvipSettings())
  }

  handleSubmit(cb) {
    this.props.dispatch(saveLocation(this.props.settings.base_zip, this.props.settings.agent_distance_category))
      .then((response) => {
        if (response.location_saved) {
          cb()
        } else {
          this.props.dispatch(showModal('ChallengeAdditionalLicensesModal', response.challenge_additional_licenses))
        }
      })
  }

  render() {

    const shouldDisableSubmit = !this.props.settings.agent_distance_category || !this.props.settings.base_zip || this.props.settings.isValidating || (this.props.settings.isDirty && !this.props.settings.found)

    return <SettingsStep shouldDisableSubmit={shouldDisableSubmit} onSubmit={this.handleSubmit} {...this.props}>
      <SettingsLocation {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings, auth: state.auth }), mapDispatchToProps)(SettingsLocationContainer)
